module.exports = __webpack_public_path__ + "static/img/helmet.018924d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/helmet.png
// module id = j3my
// module chunks = 0